import { render, staticRenderFns } from "./PerformanceTrend.vue?vue&type=template&id=6bb7b6f5&scoped=true"
import script from "./PerformanceTrend.vue?vue&type=script&lang=js"
export * from "./PerformanceTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb7b6f5",
  null
  
)

export default component.exports